export default __webpack_public_path__ + "static/media/4.70f03969.png";